export default __webpack_public_path__ + "static/media/amazon.14fbf64a.webp";